var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { CHANNEL, VERSION } from '../define-envs';
import KernelFactory from '../kernel-selector/kernel-factory';
import { urlTool } from '../util';
/** 引用方式枚举 */
var ChannelMap;
(function (ChannelMap) {
    ChannelMap[ChannelMap["npm"] = 0] = "npm";
    ChannelMap[ChannelMap["cdn"] = 1] = "cdn";
})(ChannelMap || (ChannelMap = {}));
/**
 * 播放器引用上报，用于内核、H5Player和Super层的引用统计
 */
var ReferenceReport = /** @class */ (function () {
    function ReferenceReport() {
        // 只上报一次
        this.isCollected = false;
        // 上报使用的atta信息
        this.attaid = '05700050920';
        this.token = '3619167286';
        this.timeout = 3000;
    }
    /**
     * 获取引用上报ReferenceReport实例
     * @returns 引用上报ReferenceReport实例
     */
    ReferenceReport.getReporter = function () {
        if (!this.reporter) {
            this.reporter = new ReferenceReport();
        }
        return this.reporter;
    };
    /**
     * 引用上报，对多层只上报一次，只是取不同值用于上报区分
     * @param from 引用来源
     * @param channel 引用方式
     * @param platform 平台号
     */
    ReferenceReport.prototype.collectUsage = function (from, channel, platform) {
        if (from === void 0) { from = 0; }
        if (channel === void 0) { channel = CHANNEL; }
        if (platform === void 0) { platform = ''; }
        if (this.isCollected)
            return;
        this.isCollected = true;
        // 取URL相关信息
        var topUrl = urlTool.getTopFrameUrl();
        var urlWithoutQuery = topUrl === null || topUrl === void 0 ? void 0 : topUrl.split('?')[0];
        var domain = urlTool.getDomainOfURL(topUrl);
        var reportInfo = {
            attaid: this.attaid,
            token: this.token,
            topUrl: "".concat(encodeURIComponent(topUrl)),
            pageUrl: "".concat(encodeURIComponent(urlWithoutQuery)),
            domain: "".concat(encodeURIComponent(domain)),
            channel: "".concat(ChannelMap[channel] || 0),
            from: "".concat(from),
            version: VERSION,
            platform: platform,
            kernel: Object.keys(KernelFactory.kernelMap).join('$'),
            _dc: "".concat(Math.random()),
        };
        this.send(reportInfo);
    };
    /**
     * 初始化时统计信息，这种不太重要的上报动作延迟到3S后，因为初始时候请求太多了
     */
    ReferenceReport.prototype.send = function (args) {
        setTimeout(function () {
            var img = new Image();
            // 这里用atta的单字段批量上报接口
            img.src = "https://h.trace.qq.com/kv?".concat(urlTool.object2string(__assign({}, args), '&'));
        }, this.timeout);
    };
    return ReferenceReport;
}());
export default ReferenceReport;
